import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Page, Header } from 'components';
import { Card, CardHeader, CardContent, CardActions, Divider, TextField, Grid, Button, colors } from '@mui/material';

import { GetTacticalAssignment, GetStrategicAssignment } from '../../actions/TransportIpAssignmentActions.js';

const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3)
	},
	container: {
		marginTop: theme.spacing(3)
	},
	tabs: {
		marginTop: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3)
	},
	paper: {
		padding: theme.spacing(1)
	},
	popover: {
		pointerEvents: 'none'
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900]
		}
	}
}));

const TransportIpAssignment = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const [tacticalHubs, setTacticalHubs] = useState();
	const [strategicHubs, setStrategicHubs] = useState();

	const user = useSelector(state => state.session.user);

	const _handleTacticalHubsChange = event => {
		setTacticalHubs(event.target.value);
	};

	const _handleStrategicHubsChange = event => {
		setStrategicHubs(event.target.value);
	};

	const _getTacticalAssignment = () => {
		const username = `${user.firstname} ${user.lastname}`;
		dispatch(GetTacticalAssignment(tacticalHubs, username, user.id));
	};

	const _getStrategicAssignment = () => {
		const username = `${user.firstname} ${user.lastname}`;
		dispatch(GetStrategicAssignment(strategicHubs, username, user.id));
	};

	return (
		<Page className={classes.root} title="IP Assignment">
			<Header module="IpAssignment" view="Transport IP Assignment" />
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardHeader title="Tactical Assignment" />
					<Divider />
					<CardContent>
						<Grid container spacing={2}>
							<Grid item md={9} xs={9}>
								<TextField
									fullWidth
									label="Hub ID"
									helperText="Example: Hub1,Hub2,Hub3"
									name="hubs"
									onChange={_handleTacticalHubsChange}
									value={tacticalHubs}
									variant="outlined"
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<Button
									color="primary"
									variant="contained"
									size="large"
									onClick={_getTacticalAssignment}
								>
									Run Tactical Assignment
								</Button>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</div>
			<div className={clsx(classes.container)}>
				<Card className={classes.container}>
					<CardHeader title="Strategic Assignment" />
					<Divider />
					<CardContent>
						<Grid container spacing={2}>
							<Grid item md={9} xs={9}>
								<TextField
									fullWidth
									label="Hub ID"
									helperText="Example: Hub1,Hub2,Hub3"
									name="hubs"
									onChange={_handleStrategicHubsChange}
									value={strategicHubs}
									variant="outlined"
								/>
							</Grid>
							<Grid item md={3} xs={3}>
								<Button
									color="primary"
									variant="contained"
									size="large"
									onClick={_getStrategicAssignment}
								>
									Run Strategic Assignment
								</Button>
							</Grid>
						</Grid>
					</CardContent>
				</Card>
			</div>
		</Page>
	);
};

export default TransportIpAssignment;
